(function () {
  'use strict';

  angular.module('ringbaPortal.services').factory('notificationService', notificationService);

  function notificationService(
    _,
    $http,
    ngAuthSettings,
    promiseCacheService
  ) {

    const PAGE_SIZE = 100;
    const sharedNotificationObject = {
      messages: [],
      unReadCount: 0,
      totalCount: undefined,
      paginationKey: undefined,
      unreadMessages: [],
      markAllAsReadLoading: false,
      unreadMessagesLoading: false
    };

    const service = {
      getMessages: getMessages,
      getMessagesNextPage: getMessagesNextPage,
      getMessage: getMessage,
      getAllUnreadMessages: getAllUnreadMessages,
      getPreviews: getPreviews,
      markMessageRead: markMessageRead,
      markAllAsRead: markAllAsRead,
      sharedNotificationObject: sharedNotificationObject,
      updateUnreadMessages: updateUnreadMessages,
      clearSharedNotificationObject: clearSharedNotificationObject,
      getMessageUntilUnread: getMessageUntilUnread
    };

    return service;

    function getMessages(totalCountChanged) {
      if (!sharedNotificationObject.markAllAsReadLoading && !sharedNotificationObject.unreadMessagesLoading) {
        if (totalCountChanged || sharedNotificationObject.messages.length < PAGE_SIZE) {
          const url = _getMessagesUrl(1, PAGE_SIZE, sharedNotificationObject.totalCount);
          return promiseCacheService.getCallWithCachedPromise(url, url, 5).then(function (response) {
            sharedNotificationObject.messages = response.data.notification.messages;
            sharedNotificationObject.paginationKey = response.data.notification.paginationKey;
            updateUnreadMessages();
            return sharedNotificationObject.messages;
          });
        } else {
          return getMessagesNextPage();
        }
      }
    }

    function getMessagesNextPage() {
      if (sharedNotificationObject.messages &&
        sharedNotificationObject.totalCount &&
        sharedNotificationObject.paginationKey &&
        sharedNotificationObject.messages.length < sharedNotificationObject.totalCount) {
        const nextPage = Math.ceil(sharedNotificationObject.messages.length / PAGE_SIZE) + 1;
        const url = _getMessagesUrl(nextPage, PAGE_SIZE, sharedNotificationObject.paginationKey);
        return $http.get(url).then(function (response) {
          sharedNotificationObject.messages = sharedNotificationObject.messages.concat(response.data.notification.messages);
          updateUnreadMessages();
          return sharedNotificationObject.messages;
        });
      }
    }

    async function getAllUnreadMessages() {
      sharedNotificationObject.unreadMessagesLoading = true;
      const previews = await getPreviews();
      const paginationKey = previews.counts.count;
      const unreadCountApi = previews.counts.unReadCount;
      // set pagination key to total count
      sharedNotificationObject.paginationKey = paginationKey;
      let nextPage = Math.ceil(sharedNotificationObject.messages.length / PAGE_SIZE) + 1;
      const pagesCalled = [];
      // this isn't reliable; unreadCount will sometimes be correct, but often not, since API returns values not respecting 12 month expiration
      while (sharedNotificationObject.unreadMessages.length < unreadCountApi) {
        if (!pagesCalled.includes(nextPage)) {
          const url = _getMessagesUrl(nextPage, PAGE_SIZE, paginationKey);
          const response = await $http.get(url);
          const messages = response.data.notification.messages;
          // if no more messages return, done. this is the real condition for the while
          if (messages.length === 0) {
            break;
          }
          sharedNotificationObject.messages = sharedNotificationObject.messages.concat(messages);
          updateUnreadMessages();
          pagesCalled.push(nextPage);
          nextPage++;
        }
      }
      sharedNotificationObject.unreadMessagesLoading = false;
    }

    async function getMessageUntilUnread() {
      sharedNotificationObject.unreadMessagesLoading = true;
      const previews = await getPreviews();
      const paginationKey = previews.counts.count;
      // set pagination key to total count
      sharedNotificationObject.paginationKey = paginationKey;
      let unreadMessagesInState = false;
      let nextPage = Math.ceil(sharedNotificationObject.messages.length / PAGE_SIZE) + 1;
      const pagesCalled = [];
      while (!unreadMessagesInState && sharedNotificationObject.unreadMessages.length === 0) {
        if (!pagesCalled.includes(nextPage)) {
          const url = _getMessagesUrl(nextPage, PAGE_SIZE, paginationKey);
          const response = await $http.get(url);
          const messages = response.data.notification.messages;
          // if no more messages return, done
          if (messages.length === 0) {
            break;
          }
          sharedNotificationObject.messages = sharedNotificationObject.messages.concat(messages);
          updateUnreadMessages();
          unreadMessagesInState = messages.find((message) => message.isRead == false);
          pagesCalled.push(nextPage);
          nextPage++;
        }
      }
      sharedNotificationObject.unreadMessagesLoading = false;
    }


    function getMessage(messageId) {
      const url = _getBaseUrl() + '/' + messageId;
      return $http.get(url).then(function (response) {
        const message = response.data.message;
        return message;
      });
    }

    function getPreviews(tryFillUnreadMessages) {
      const url = _getBaseUrl() + '/all';
      return promiseCacheService.getCallWithCachedPromise(url, url, 1).then(function (response) {
        const counts = response.data.counts;
        sharedNotificationObject.totalCount = counts.count;
        tryFillUnreadMessages ? updateUnreadMessages(true) : updateUnreadMessages();

        return response.data;
      });
    }

    function markMessageRead(messageId) {
      const url = _getBaseUrl() + '/' + messageId;
      return $http.put(url, {
        id: messageId
      }).then(function (response) {
        return response.data;
      });
    }

    async function markAllAsRead() {
      sharedNotificationObject.markAllAsReadLoading = true;
      // get preview total count and unread count aren't reliable values; API doesn't return counts respecting the 12 month expiration of messages in AeroSpike db
      // so we get all unread messages first before calling this function

      // call mark message read for each unread message with 5ms delay
      for (let x=0; x < sharedNotificationObject.unreadMessages.length; x++) {
        // Catch API error and do nothing, if failure. Worst case scenario, user will have to click button twice
        const result = await markMessageRead(sharedNotificationObject.unreadMessages[x].id).catch(() => null);
        // update state on result - assume success on mark as read
        // worst case, notification will update correct number on next pull
        if (result) {
          const readMessage = _.find(sharedNotificationObject.messages, function (m) {
            return m.id === sharedNotificationObject.unreadMessages[x]?.id;
          });
          if (readMessage) {
            readMessage.isRead = true;
          }
          sharedNotificationObject.unReadCount--;
        }

        // 5ms timeout to avoid flooding the API
        // Single calls for now since Aerospike is unable to Batch
        await _timeout(5);
      }

      sharedNotificationObject.markAllAsReadLoading = false;
    }


    function updateUnreadMessages(tryFillUnreadMessages) {
      const unreadmessages = _.filter(sharedNotificationObject.messages, function (m) {
        return !m.isRead;
      });
      sharedNotificationObject.unreadMessages = unreadmessages;
      sharedNotificationObject.unReadCount = unreadmessages.length;
      if (tryFillUnreadMessages) {
        _tryFillUnreadMessages();
      }
    }

    function clearSharedNotificationObject() {
      sharedNotificationObject.messages = [];
      sharedNotificationObject.unReadCount = 0;
      sharedNotificationObject.totalCount = undefined;
      sharedNotificationObject.paginationKey = undefined;
      sharedNotificationObject.unreadMessages = [];
    }

    function _timeout(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }

    function _tryFillUnreadMessages() {
      if (sharedNotificationObject.unReadCount > 0 &&
        sharedNotificationObject.unreadMessages.length === 0 &&
        !sharedNotificationObject.unreadMessagesLoading) {
        getMessageUntilUnread();
      }
    }

    function _getBaseUrl() {
      return ngAuthSettings.apiServiceBaseUri + 'notifications';
    }

    function _getMessagesUrl(page, pageSize, paginationKey) {
      let url = _getBaseUrl();
      if (page || pageSize || paginationKey) {
        url += '?';
        if (page) {
          url += '&page=' + page;
        }
        if (pageSize) {
          url += '&pageSize=' + pageSize;
        }
        if (paginationKey) {
          url += '&paginationKey=' + paginationKey;
        }
      }
      return url;
    }
  }
})();
